<template>
  <div style="height:95vh;">
    <v-row align="center" justify="center" class="fill-height">
      <v-col>
        <v-card max-width="400" class="mx-auto my-auto pa-5 elevation-hb">
          <div class="text-center">
            <img width="80%" src="@/assets/waplogohubble.png" />
          </div>
          <v-divider class="my-5"></v-divider>
          <v-form>
            <b> Login </b>
            <v-text-field color="primary" placeholder="Usuário" v-model="user.login" required @keyup.enter="login()" />
            <b> Senha </b>
            <v-text-field
              color="primary"
              required
              v-model="user.password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Senha"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              @keyup.enter="login()"
            />
          </v-form>
          <v-btn color="primary" @click="login" block depressed large class="mt-5">Login</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseApiUrl, showError, userPayload } from '@/global'
import axios from 'axios'
export default {
  data: () => ({
    showPassword: false,
    valid: true,
    user: {},
  }),
  computed: mapState(['logged']),

  methods: {
    login() {
      axios
        .post(`${baseApiUrl}/login`, this.user)
        .then((res) => {
          localStorage.setItem(userPayload, JSON.stringify(res.data.payload))

          this.$store.dispatch('setUserInfo', {
            user: res.data.payload.user,
            menu: res.data.payload.menu,
            permissions: res.data.payload.permissions,
          })
          this.$router.push({ path: '/' })
        })
        .catch(showError)
    },
  },
}
</script>

<style scoped>
.v-application {
  background: #1f1f1f !important;
}
</style>
